import { render, staticRenderFns } from "./FindingItemImages.vue?vue&type=template&id=07127b97&scoped=true"
import script from "./FindingItemImages.vue?vue&type=script&lang=js"
export * from "./FindingItemImages.vue?vue&type=script&lang=js"
import style0 from "./FindingItemImages.vue?vue&type=style&index=0&id=07127b97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07127b97",
  null
  
)

export default component.exports